import { api } from "../lib/api";

const MARK = /<!--\s*IMAGE:\s*([\s\S]*?)-->/g;

export const genImage = async (title, keyword, details) => {
  const { data } = await api.post("/admin/ai/image", { title: title.slice(0, 200), keyword: (keyword || "").slice(0, 120), details: (details || "").slice(0, 500) }, { timeout: 120000 });
  return data;
};

// Ensures the html has `count` IMAGE placeholders, adding them before later <h2> headings if the AI skipped them.
export const withPlaceholders = (html, count) => {
  const found = [...html.matchAll(MARK)].length;
  if (found >= count) return html;
  const heads = [...html.matchAll(/<h2[^>]*>([\s\S]*?)<\/h2>/gi)].filter((m) => !/faq/i.test(m[1]));
  const picks = heads.slice(1).filter((_, i) => i % 2 === 0).slice(0, count - found);
  let out = html;
  picks.reverse().forEach((m) => {
    const label = m[1].replace(/<[^>]+>/g, "").trim();
    out = `${out.slice(0, m.index)}<!--IMAGE: ${label}-->\n${out.slice(m.index)}`;
  });
  return out;
};

export const placeholders = (html, count) => [...html.matchAll(MARK)].slice(0, count).map((m) => ({ raw: m[0], desc: m[1].trim() }));

export const stripPlaceholders = (html) => html.replace(MARK, "");

export const imgTag = (url, alt) => `<img src="${url}" alt="${alt.replace(/"/g, "&quot;")}" />`;
